import { NgModule } from '@angular/core';
import { MenubarModule } from 'primeng/menubar';
import { AuthConfigService } from 'projects/dop-core/src/public-api';
import { DopMenuComponent } from './dop-menu.component';



@NgModule({
  declarations: [DopMenuComponent],
  imports: [
    MenubarModule
  ],
  exports: [DopMenuComponent],
  providers : [AuthConfigService]
})
export class DopMenuModule { }
